module.exports = __webpack_public_path__ + "img/shenpiliucheng.25fb5765.png";